import React from 'react'
import { successtick } from "../../constants/Images";
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
export default function Joinsuccess() {
    const [auctionname, setAuctionname] = useState(localStorage.getItem('cjoined'))
    const [playerName, setPlayerName] = useState(localStorage.getItem('cjoined_player_name'))
    const [playerMobno, setPlayerMobno] = useState(localStorage.getItem('cjoined_player_mobno'))
    const [helplineMob, setHelplineMob] = useState(localStorage.getItem('cjoined_helpline_mob'))
    const [helplineName, setHelplineName] = useState(localStorage.getItem('cjoined_helpline_name'))
    
    // Auto scroll to top when component mounts
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    return (
        <div className='joinsuccess' style={{ minHeight: 'calc(100vh - 200px)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '40px 20px' }}>
            <div>
                <h3>
                    <span className='sucauc' style={{ display: 'block', marginBottom: '10px', fontSize: '2rem', fontWeight: 'bold' }}>
                        {playerName} {playerMobno && `(${playerMobno})`}
                    </span>
                    You have successfully joined <span className='sucauc'>{auctionname}</span>
                </h3>
            </div>
            <div>
                <img src={successtick} alt="" /> 
            </div>
            {(helplineMob || helplineName) && (
                <div style={{ marginTop: '20px', fontSize: '18px', color: '#333' }}>
                    <p style={{ margin: '5px 0' }}>
                        <strong>Helpline No.:</strong> {helplineMob} {helplineName && `(${helplineName})`}
                    </p>
                </div>
            )}
            {localStorage.getItem('user') &&
            <div className='joinback' ><Link to='/dashboard'><button className='joinbackbtn'>Go to Dashboard</button></Link></div>
            }
            {/* <button>Back</button> */}
        </div>
    )
}
